import { ThemeData } from "../models/ThemeData"
export default function setThemeData(data: ThemeData, vueInstance: any) {
  if (!data) return
  if (data.font_color)
    vueInstance.$root.$data.theme_data.font_color = data.font_color
  if (data.font_family)
    vueInstance.$root.$data.theme_data.font_family = data.font_family
  if (data.theme_color)
    vueInstance.$root.$data.theme_data.theme_color = data.theme_color
  if (data.font_size)
    vueInstance.$root.$data.theme_data.font_size =
      typeof data.font_size == "string"
        ? parseInt(data.font_size)
        : data.font_size
}
